import { render } from "./BaseShareLinkPage.vue?vue&type=template&id=5c2f9f44&scoped=true"
import script from "./BaseShareLinkPage.vue?vue&type=script&lang=js"
export * from "./BaseShareLinkPage.vue?vue&type=script&lang=js"

import "./BaseShareLinkPage.vue?vue&type=style&index=0&id=5c2f9f44&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2f9f44"]])

export default __exports__